import { Autocomplete, TextField } from "@mui/material";
import React from "react";
import RelatedAgenciesButton from "./RelatedAgenciesButton";
import RelatedAgenciesData from "./RelatedAgenciesData";
import BackToParentAgencyButton from "./BackToParentAgencyButton";

const RelatedAgenciesComboBox = () => {
  const [inputId, setInputId] = React.useState("");
  const data = RelatedAgenciesData();
  const agencyName = sessionStorage.getItem("agencyName");
  const filteredData = data.filter(
    (item) => item.value !== agencyName
  );
  
  const handleClick = (e, value) => {
    if (value === null) {
      setInputId("");
      return;
    }
    setInputId(value.id);
  };

  const parentAgencyId = sessionStorage.getItem("parentAgency")

  return (
    <div style={{ display: "flex", justifyContent: "right" }}>
      <Autocomplete
        options={filteredData}
        getOptionLabel={(option) => option.value || ""}
        sx={{ width: 400, marginRight: 2 }}
        onClick={(e, value) => {
          handleClick(e, value);
        }}
        onChange={(e, value) => {
          handleClick(e, value);
        }}
        renderInput={(params) => (
          <TextField {...params} label="Related Agencies" />
        )}
      />
      <RelatedAgenciesButton inputId={inputId} />
      <BackToParentAgencyButton inputId={parentAgencyId} />
    </div>
  );
};

export default RelatedAgenciesComboBox;
